import React, { Component } from "react"
import {
  Dialog,
  Typography,
  DialogContent,
  Divider,
  DialogActions,
  IconButton,
  Icon,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Button,
  Switch,
  Tooltip,
  Hidden,
} from "@material-ui/core"
import classNames from "classnames"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"

export const filterOptions = [
  {
    id: 1,
    type: "status",
    name: "Standby",
    description: "Shoots that are on standby",
    func: shoot => {
      return !shoot.firm && shoot.status !== "cancelled"
    },
  },
  {
    id: 2,
    type: "status",
    name: "Firm",
    description: "Shoots that are firm",
    func: shoot => {
      return shoot.firm && shoot.status !== "cancelled"
    },
  },
  {
    id: 3,
    type: "standard",
    name: "Wrapped",
    description: "Shoots that are wrapped",
    func: shoot => {
      return shoot.status === "wrapped" && shoot.status !== "cancelled"
    },
  },
  {
    id: 4,
    type: "standard",
    name: "Open",
    description: "Not all crew are firm",
    func: shoot => {
      return (
        shoot.roles.filter(y => !y.user_id).length > 0 &&
        shoot.status === "open" &&
        shoot.status !== "cancelled"
      )
    },
  },
  {
    id: 5,
    type: "standard",
    name: "Booked",
    description: "All crew are firm",
    func: shoot => {
      return shoot.status === "booked" && shoot.status !== "cancelled"
    },
  },
  {
    id: 7,
    type: "standard",
    name: "Cancelled",
    description: "Shoots marked as cancelled",
    func: shoot => {
      return shoot.status === "cancelled"
    },
  },
  {
    id: 8,
    type: "standard",
    name: "Billed",
    description: "Shoots that are billed",
    func: shoot => {
      return shoot.status === "billed" && shoot.status !== "cancelled"
    },
  },
  {
    id: 9,
    type: "standard",
    name: "Paid",
    description: "Shoots that are paid",
    func: shoot => {
      return shoot.status === "paid" && shoot.status !== "cancelled"
    },
  },
]
const defaultState = {
  checked: [],
  and: false,
}
class FilterDialog extends Component {
  state = defaultState

  componentDidUpdate(p) {
    if (!p.open && this.props.open) {
      // make filters list in modal reflect the filters being used
      this.setState({
        checked: this.props.filters.map(x =>
          filterOptions.findIndex(y => x.name === y.name)
        ),
        and: this.props.and,
      })
    }
  }
  onChange = data => {
    this.props.onChange(data, this.state.and)
    this.props.setFilter(data, this.state.and)
  }
  render() {
    const { props, state, onChange } = this
    const { open, onClose, classes } = props
    const { checked, and } = state
    return (
      <Dialog onClose={onClose} open={open}>
        <DialogContent className={classes.dialogTitle}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography style={{ fontWeight: "bold", color: "white" }}>
              Pick Filters
            </Typography>
            <div style={{ flexGrow: 1 }} />
            <IconButton onClick={onClose}>
              <Icon style={{ color: "white" }}>close</Icon>
            </IconButton>
          </div>
        </DialogContent>
        <Divider />
        <DialogContent>
          <List component="nav">
            {filterOptions.map((x, i) => {
              return (
                <ListItem
                  style={{ marginRight: "128px" }}
                  key={i}
                  button
                  disableRipple
                  onClick={e => {
                    if (checked.indexOf(i) >= 0) {
                      this.setState({
                        checked: checked.filter(x => x !== i),
                      })
                    } else {
                      this.setState({ checked: checked.concat([i]) })
                    }
                  }}
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={checked.indexOf(i) >= 0}
                      disableRipple
                      color="primary"
                    />
                  </ListItemIcon>
                  <ListItemText primary={x.name} secondary={x.description} />
                </ListItem>
              )
            })}
          </List>
        </DialogContent>
        {/* WEB VIEW */}
        <Hidden smDown>
          <DialogActions style={{ justifyContent: "space-between" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                marginLeft: "16px",
              }}
            >
              <Switch
                color="primary"
                checked={Boolean(and)}
                onChange={e => {
                  this.setState({ and: !this.state.and })
                }}
              />
              <Tooltip title="Shoots have to match all filters" placement="top">
                <Typography
                  className={classNames("", {
                    [props.classes.selected]: and,
                    [props.classes.unselected]: !and,
                  })}
                  onClick={e => {
                    this.setState({ and: !this.state.and })
                  }}
                >
                  Match All
                </Typography>
              </Tooltip>
            </div>
            <div style={{ width: "100%", display: "flex" }}>
              <Button
                variant="text"
                color="primary"
                onClick={e => {
                  onChange([])
                  onClose()
                }}
                style={{ marginLeft: 8 }}
              >
                Clear Filters
              </Button>
              <Button
                onClick={e => {
                  onChange(
                    filterOptions.filter((x, i) => checked.indexOf(i) >= 0)
                  )
                  onClose()
                }}
                variant="contained"
                color="primary"
                style={{ marginLeft: 8 }}
              >
                Save
              </Button>
            </div>
          </DialogActions>
        </Hidden>
        {/* MOBILE VIEW */}
        <Hidden mdUp>
          <DialogActions style={{ flexDirection: "column" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                marginLeft: "16px",
                padding: 10,
              }}
            >
              <Switch
                color="primary"
                checked={Boolean(and)}
                onChange={e => {
                  this.setState({ and: !this.state.and })
                }}
              />
              <Tooltip title="Shoots have to match all filters" placement="top">
                <Typography
                  className={classNames("", {
                    [props.classes.selected]: and,
                    [props.classes.unselected]: !and,
                  })}
                  onClick={e => {
                    this.setState({ and: true })
                  }}
                >
                  Match All
                </Typography>
              </Tooltip>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="text"
                color="primary"
                onClick={e => {
                  onChange([])
                  onClose()
                }}
                style={{ padding: 8 }}
              >
                Clear Filters
              </Button>
              <Button
                onClick={e => {
                  onChange(
                    filterOptions.filter((x, i) => checked.indexOf(i) >= 0)
                  )
                  onClose()
                }}
                variant="contained"
                color="primary"
                style={{ marginLeft: 8 }}
              >
                Save
              </Button>
            </div>
          </DialogActions>
        </Hidden>
      </Dialog>
    )
  }
}

export default withStyles(styles)(FilterDialog)
